import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import rModals from './reducer-modals';
import rUser from './reducer-user';
import rSession from './reducer-session';
import rPages from './reducer-flow';
import rServerData from './reducer-server-data';
import rLoading from './reducer-loading';
import rVideoSession from './reducer-videosession';
import rSocket from './reducer-socket';
import rCart from './reducer-cart';

export const RootReducer = (history) => (
  combineReducers({
    router: history && connectRouter(history),
    rModals,
    rUser,
    rSession,
    rPages,
    rServerData,
    rLoading,
    rVideoSession,
    rSocket,
    rCart,
  })
);
